import api from './api';

export interface WorkspaceStateResponse {
  client_id: string | null;
  client_name: string | null;
  last_visited_path: string | null;
  last_active_at: string;
}

export interface DraftUpsert {
  entity_type: string;
  entity_id: string;
  field_key: string;
  content: string;
}

export interface DraftResponse {
  id: number;
  entity_type: string;
  entity_id: string;
  field_key: string;
  content: string;
  updated_at: string;
}

export interface ResearchLogResponse {
  id: number;
  client_id: string | null;
  matter_id: number | null;
  search_type: string;
  query_text: string;
  result_count: number | null;
  created_at: string;
}

export const workspaceApi = {
  getWorkspaceState: async (clientId?: string): Promise<WorkspaceStateResponse | null> => {
    const response = await api.get('/workspace/state', { params: clientId ? { client_id: clientId } : {} });
    return response.data;
  },

  updateWorkspaceState: async (clientId: string | null, path: string): Promise<void> => {
    await api.put('/workspace/state', { last_visited_path: path }, { params: clientId ? { client_id: clientId } : {} });
  },

  listRecentWorkspaces: async (limit = 5): Promise<WorkspaceStateResponse[]> => {
    const response = await api.get('/workspace/recent', { params: { limit } });
    return response.data;
  },

  upsertDraft: async (data: DraftUpsert): Promise<DraftResponse> => {
    const response = await api.post('/workspace/drafts', data);
    return response.data;
  },

  getDraft: async (entityType: string, entityId: string, fieldKey: string): Promise<DraftResponse | null> => {
    try {
      const response = await api.get(`/workspace/drafts/${entityType}/${entityId}/${fieldKey}`);
      return response.data;
    } catch {
      return null;
    }
  },

  deleteDraft: async (entityType: string, entityId: string, fieldKey: string): Promise<void> => {
    await api.delete(`/workspace/drafts/${entityType}/${entityId}/${fieldKey}`);
  },

  getResearchLog: async (clientId?: string, limit = 50, matterId?: number): Promise<ResearchLogResponse[]> => {
    const response = await api.get('/workspace/research-log', { params: { client_id: clientId, matter_id: matterId, limit } });
    return response.data;
  },
};
